export enum OfferFormField {
  Offer = 'offer',
}

export type OfferFormModel = {
  [OfferFormField.Offer]: string
}
